import { Button, Space, Typography } from 'antd';
import { DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import logger from '@/utils/logger';

const { Text } = Typography;

export default function DebugLogPanel() {
  const handleDownload = () => {
    logger.downloadLogs(`auth-debug-${new Date().toISOString()}.txt`);
  };

  const handleClear = () => {
    if (window.confirm('Are you sure you want to clear all debug logs?')) {
      logger.clear();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        background: '#fff',
        padding: '12px 16px',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 9999,
        border: '1px solid #d9d9d9',
      }}
    >
      <Space direction="vertical" size="small">
        <Text strong style={{ fontSize: 12 }}>
          Debug Logs
        </Text>
        <Space>
          <Button
            type="primary"
            size="small"
            icon={<DownloadOutlined />}
            onClick={handleDownload}
          >
            Download
          </Button>
          <Button
            danger
            size="small"
            icon={<DeleteOutlined />}
            onClick={handleClear}
          >
            Clear
          </Button>
        </Space>
      </Space>
    </div>
  );
}
